import Vue from "vue";
import translate from "./translate";


if (document.getElementById('app-offer-erecruter')) {

    let id = null;
    const queryString = window.location;

    if (queryString) {
        let url = new URL(queryString),
            params = new URLSearchParams(url.search);
        id = params.get('id');
    }

    if (!id)
        window.open('/', '_self');

    var erecruterApp = new Vue({
        el: '#app-offer-erecruter',
        data: {
            settings: {
                // url: process.env.API_URL,
                // url: 'https://apikariera.suus.com',
                url: 'https://apis.24t.pl',
                // key: process.env.API_TOKEN,
                key: 'qfasg-4g73d-0kfewa-1dy6nc',
                loaderClassName: null, //'lds-ripple',
                loaderVisibleClassName: 'is-visible',
                contentClassName: 'c-results',
            },
            offer: null,
            similar: []
        },
        mounted: function () {
            this.getOfferData();
            this.getSimilarOffers();
        },
        computed: {
            isForeign: function () {
                // return true;
                if (!this.offer)
                    return false;
                if (!this.offer.country)
                    return false;

                return this.offer.country.toLowerCase() !== 'polska';
            },
            applyLabel: function () {
                return this.isForeign ? 'Apply' : this.applyLabel2;
            },
            applyLabel2: function () {
                return this.lang == 'en-EN' ? 'Apply' : 'Aplikuj';
            },
            benefits: function () {
                if (!this.offer)
                    return [];
                // this.offer.benefits = '•\tPracę w dużej stabilnej (polskiej) firmie, która szybko się rozwija, ale nie jest korporacją, •\tDołączysz do stabilnego zespołu, który cechuję pozytywne nastawienie oraz duże pokłady wiedzy i doświadczenia, którym chętnie się z Tobą podzielimy, •\tPracę w trybie hybrydowym (po wdrożeniu), •\tPosiadamy zdywersyfikowany portfel klientów różnych rozmiarów i działających w różnych branżach. Uważamy to za wielką wartość, gdyż jesteśmy odporni na ciągle zmieniające się trendy, •\tTo co nas wyróżnia to unikatowa kultura organizacyjna – traktujemy się po ludzku, •\tDbamy o zdrowie naszych pracowników, dlatego w ofercie mamy Medicover, a także dofinansowanie do karty Multisport lub Medicover Sport, •\tZdrowie psychiczne jest dla nas równie ważne, dlatego pracownicy mogą skorzystać z bezpłatnej i anonimowej pomocy psychologicznej, •\tWiemy, jak ważne są pierwsze miesiące w nowej firmie, dlatego dużą wagę przykładamy do onboardingu nowych pracowników. Otrzymasz kompletne wdrożenie firmowe i stanowiskowe ze stałym mentoringiem przełożonego i członków zespołu. Realne perspektywy rozwoju – rośniesz razem z firmą (a robimy to w SUUS-owym tempie!), •\tJako firma ciągle się rozwijamy i Ty też będziesz mieć taką możliwość uczestnicząc w szeregu szkoleń wewnętrznych i zewnętrznych, •\tNasze biura dostosowaliśmy do potrzeb i trybu pracy pracowników - różne strefy pracy i nowoczesny sprzęt – po prostu Office of the Future, •\tChcesz doskonalić swoje umiejętności językowe? Dołącz do kursu języka angielskiego czy innych języków obcych współfinansowanych przez firmę, •\t„Poleć do SUUS’a” to nasz wewnętrzny program płatnych poleceń pracowniczych, •\tKażda praca niesie za sobą wynagrodzenie, bo nie tylko radością z pracy żyjemy. Oprócz wynagrodzenia podstawowego masz możliwość uzyskania premii kwartalnej, •\tPoza super zespołem mamy też dobrą kawę na pokładzie 😉, •\tNa koniec napiszemy, że oferujemy naszą wiedzę z zakresu logistyki, którą zbudowaliśmy na przestrzeni ostatnich 30 lat w Polsce i na całym świecie. Poznaj nas lepiej i aplikuj do SUUSa!'
                if (!this.offer.benefits)
                    return [];

                return this.offer.benefits.split("•");
            },
            lang: function () {
                return document.getElementsByTagName('html')[0].getAttribute('lang');
            },
            showAllLabel: function () {
                return this.lang == 'en-EN' ? 'Show all offers' : 'Pokaż wszystkie oferty';
            },
            learnMoreLabel: function () {
                return this.lang == 'en-EN' ? 'Learn more' : 'Dowiedz się więcej';
            },
            jobOfferUrl: function () {
                return this.lang == 'en-EN' ? 'job-offer.html' : 'ogloszenie.html';
            },
            relatedDesktopTitle: function () {
                return this.lang == 'en-EN' ? 'You may also be interested in:' :'Może zainteresować Cię również:';
            },
            relatedMobileTitle: function () {
                return this.lang == 'en-EN' ? 'You may be interested:' :'Może Cię zainteresować:';
            },
        },
        methods: {
            getOfferData() {
                this.request("/api/show/" + this.settings.key + '/' + id, (data) => {
                    // console.log(data)
                    this.offer = data;

                    //set meta data
                    document.title = this.offer.title;
                    document.querySelector('meta[property="og:title"]').setAttribute('content', this.offer.title);
                    document.querySelector('meta[name="twitter:title"]').setAttribute('content', this.offer.title);
                    document.querySelector('meta[property="og:url"]').setAttribute('content', window.location.href);
                    document.querySelector('meta[property="twitter:url"]').setAttribute('content', window.location.href);



                    setTimeout(window.benefitsCarousel);
                });
            },
            getSimilarOffers() {
                this.request("/api/similar/" + this.settings.key + '/' + id, (data) => {
                    // console.log(data)
                    this.similar = data;
                });
            },
            goTo: function (url) {
                window.open(url, '_self');
            },
            request: function (url, callback) {
                let request = new XMLHttpRequest();
                let that = this;
                // that.showPreloader();
                // that.hideList();
                request.onreadystatechange = function () {
                    if (request.readyState === 4 && request.status === 200) {
                        // that.hidePreloader();
                    } else {
                        // that.showPreloader();
                    }
                }

                request.open('GET', this.settings.url + url, true);

                request.onload = function () {
                    if (this.status >= 200 && this.status < 400) {
                        callback(JSON.parse(this.response))
                    }
                    else if (this.status === 401) {
                        setTimeout(() => {
                            that.request(url, callback);
                        },500);
                    }
                    else {
                        window.open('/index.html', '_self')
                    }
                };
                request.send();
            },
            translate: function (value) {
                return translate(value);
            },
            cleanHTML: function(htmlString, removeText = []) {

                if(removeText.length) {
                    removeText.forEach(text => {
                        const regex = new RegExp(`<.*?>\\s*${text}[:]?`, 'gi');
                        htmlString = htmlString.replace(regex, '')
                    });
                }

                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = htmlString;

                const tagsToRemove = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
                tagsToRemove.forEach(tag => {
                    const elements = tempDiv.querySelectorAll(tag);
                    elements.forEach(el => el.remove());
                });

                // span: keep the text, drop only the tag (Word-pasted HTML wraps every line in a styled span)
                tempDiv.querySelectorAll('span').forEach(el => {
                    el.replaceWith(...el.childNodes);
                });

                const elementsWithStyle = tempDiv.querySelectorAll('[style]');
                elementsWithStyle.forEach(el => el.removeAttribute('style'));

                const emptyElements = tempDiv.querySelectorAll('*:empty');
                emptyElements.forEach(el => {
                    if (el.tagName.toLowerCase() !== 'br') {
                        el.remove();
                    }
                });

                return tempDiv.innerHTML;
            }
        }
    });
}
